import { gql } from '@apollo/client';

export const PUBLIC_RESTAURANT_QUERY = gql`
  query AuthStackContext_GetGuestModeContent($businessOrganizationUUID: uuid!) {
    getGuestModeContent(business_organization_id: $businessOrganizationUUID) {
      chat {
        restaurant {
          name
          address {
            address
            timezone
            uuid
          }
          uuid
        }
        supplier {
          address {
            country_code
            uuid
          }
          supplier_metadata {
            display_item_code
            dynamic_config
            uuid
          }
          uuid
        }
        uuid
        dynamic_config
      }
    }
  }
`;

export const WHITELABEL_CONFIG_QUERY = gql`
  query AuthStackContext_WhiteLabelConfig($businessOrganizationUUID: uuid!) {
    getWhitelabelConfig(business_organization_id: $businessOrganizationUUID) {
      render_contact_form
      translated_become_customer_address_label
      translated_become_customer_name_label
      translated_tagline
      whitelabel_config {
        app_background_image_url
        app_background_landscape_video_url
        app_background_video_url
        app_landing_logo_image
        become_customer_url
        cms_enabled
        default_login_method
        guest_mode_enabled
        ios_icon_image
        login_methods
        login_request_enabled
        translations_enabled
        uuid
      }
    }
  }
`;
